import { LinkedRelationshipsForm_P_PL } from '../../private/LinkedRelationships_P_PL';

/**
 * - OtherBusiness (LTD, PLC, Other, Unlimited, Partnership)
 * - OperatingLease
 */
export const LinkedRelationshipsForm_OB_OL = LinkedRelationshipsForm_P_PL;
